/**
 * Gesetzliche Feiertage als Vorschlag fuer die Ausnahmetage eines Sendeprofils.
 *
 * ABWEICHUNG VOM AUFTRAG, mit Absicht: dort war eine fest eingetragene Liste
 * mit Jahresangabe vorgesehen, die sich bei Ablauf als veraltet meldet. Die
 * beweglichen Feiertage haengen aber alle am Ostersonntag, und der laesst sich
 * ausrechnen. Eine gerechnete Fassung kann nicht veralten — damit entfaellt
 * die ganze Fehlerklasse, die die Jahresangabe abfedern sollte, statt sie nur
 * sichtbar zu machen.
 *
 * WAS HIER NICHT DRINSTEHT: Feiertage einzelner Bundeslaender (Fronleichnam,
 * Allerheiligen, Reformationstag, Heilige Drei Koenige, Mariae Himmelfahrt,
 * Buss- und Bettag). Sie gelten je nach Land verschieden, und eine Liste, die
 * fuer die Haelfte der Empfaenger falsch ist, waere schlechter als keine. Wer
 * sie braucht, traegt sie von Hand nach — dafuer ist das Feld da.
 */
/** Ostersonntag nach der Gaussschen Osterformel in der Fassung von Meeus. */
export function ostersonntag(jahr) {
    const a = jahr % 19;
    const b = Math.floor(jahr / 100);
    const c = jahr % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const monat = Math.floor((h + l - 7 * m + 114) / 31);
    const tag = ((h + l - 7 * m + 114) % 31) + 1;
    // UTC, weil hier nur das Kalenderdatum zaehlt und eine Ortszeit den Tag je
    // nach Rechnerzeitzone um eins verschieben wuerde.
    return new Date(Date.UTC(jahr, monat - 1, tag));
}
function alsDatum(basis, plusTage) {
    const d = new Date(basis.getTime() + plusTage * 86_400_000);
    return d.toISOString().slice(0, 10);
}
/**
 * Bundesweite Feiertage eines Jahres.
 *
 * Heiligabend und Silvester sind keine gesetzlichen Feiertage, stehen aber
 * mit drin: eine Werbemail am 24.12. wird nicht gelesen, sondern als Spam
 * gemeldet. Sie sind als `eingeschraenkt` gekennzeichnet, damit die
 * Oberflaeche den Unterschied benennen kann.
 */
export function deutscheFeiertage(jahr) {
    const ostern = ostersonntag(jahr);
    return [
        { datum: `${jahr}-01-01`, name: 'Neujahr' },
        { datum: alsDatum(ostern, -2), name: 'Karfreitag' },
        { datum: alsDatum(ostern, 1), name: 'Ostermontag' },
        { datum: `${jahr}-05-01`, name: 'Tag der Arbeit' },
        { datum: alsDatum(ostern, 39), name: 'Christi Himmelfahrt' },
        { datum: alsDatum(ostern, 50), name: 'Pfingstmontag' },
        { datum: `${jahr}-10-03`, name: 'Tag der Deutschen Einheit' },
        { datum: `${jahr}-12-24`, name: 'Heiligabend', eingeschraenkt: true },
        { datum: `${jahr}-12-25`, name: '1. Weihnachtstag' },
        { datum: `${jahr}-12-26`, name: '2. Weihnachtstag' },
        { datum: `${jahr}-12-31`, name: 'Silvester', eingeschraenkt: true },
    ].sort((a, b) => a.datum.localeCompare(b.datum));
}
/** Feiertage ab heute bis zum Ende des Folgejahres — der brauchbare Vorrat. */
export function kommendeFeiertage(ab = new Date()) {
    const heute = ab.toISOString().slice(0, 10);
    const jahr = ab.getUTCFullYear();
    return [...deutscheFeiertage(jahr), ...deutscheFeiertage(jahr + 1)].filter((f) => f.datum >= heute);
}
//# sourceMappingURL=feiertage.js.map